import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/layout'
import Welcome from '@/views/index/welcome'
import Login from '@/views/login/Login'
import channelList from '@/views/channel/channelList';
import carBrandList from '@/views/car/brand/carBrandList';
import carCategoryList from '@/views/car/category/carCategoryList';
import deptList from '@/views/system/deptList';
import roleList from '@/views/system/roleList';
import sysuserList from '@/views/system/sysuserList';
import menuList from '@/views/system/menuList';
import userList from '@/views/user/userList';
import guideBookingList from '@/views/advance-order/guideBookingList';
import carLoanList from '@/views/advance-order/carLoanList';
import posterList from '@/views/popularize/poster/posterList';
import articleList from '@/views/popularize/article/articleList';
import articleAdd from '@/views/popularize/article/articleAdd';
import writingsList from '@/views/popularize/writings/writingsList';
import writingsAdd from '@/views/popularize/writings/writingsAdd';
import integralList from '@/views/integral/integralList';
import advertiseList from '@/views/front/advertiseList';
import activityList from '@/views/front/activityList';
import agreementList from '@/views/front/agreementList';
import agreementAdd from '@/views/front/agreementAdd';
import giftOrderList from '@/views/gift_order/giftOrderList'; //  礼品单
import pushList from '@/views/push/pushList'; //  推送管理
import feedbackList from '@/views/feedback/feedbackList'; //  反馈管理
import wechatSetting from '@/views/front/wechatSetting';

import activityRule from '@/views/front/activityRule';
import activityForword from '@/views/front/activityForword';
import pointFabulou from '@/views/front/pointFabulou';
import homeBrand from '@/views/front/homeBrand';

import statisticsList from '@/views/front/statisticsList';
import newPushList from '@/views/push/newPushList/newPushList'//新增的“推送管理”页面
import userInfo from '@/views/user/userInfo/userInfo'

Vue.use(Router)

let defaultRouter = [
    {
        path: '/',
        redirect: '/index',
        hidden: true,
        children: []
    },
    {
        path: '/index',
        iconCls: 'fa fa-dashboard', // 图标样式class
        name: '首页',
        component: Layout,
        alone: true,
        children: [
            {
                path: '/index',
                iconCls: 'fa fa-dashboard', // 图标样式class
                name: 'welcome',
                component: Welcome,
                meta: { requireAuth: true },
                children: []
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        children: []
    },
];

let addRouter = [
    {
        path: '/',
        iconCls: 'el-icon-tickets', // 图标样式class
        name: '首页',
        component: Layout,
        children: [
            {
                path: '/channel',
                name: '渠道管理',
                icon: 'el-icon-guide',
                component: channelList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/car/brand/list',
                name: '品牌管理',
                icon: 'el-icon-s-flag',
                component: carBrandList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/car/category/list',
                name: '车型管理',
                icon: 'el-icon-files',
                component: carCategoryList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/system/dept/list',
                name: '系统管理',
                icon: 'el-icon-setting',
                meta: { requireAuth: true },
                component: deptList,
                children: []
            },
            {
                path: '/system/role/list',
                name: '系统管理',
                icon: 'el-icon-setting',
                component: roleList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/system/sysuser/list',
                name: '系统管理',
                icon: 'el-icon-setting',
                component: sysuserList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/system/menu/list',
                name: '系统管理',
                icon: 'el-icon-setting',
                component: menuList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/user/list',
                name: '会员管理',
                icon: 'el-icon-user',
                component: userList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/advance-order/guideBooking/list',
                name: '导购单',
                icon: 'el-icon-s-order',
                component: guideBookingList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/advance-order/carloan/list',
                name: '车贷单',
                icon: 'el-icon-truck',
                component: carLoanList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/popularize/poster/list',
                name: '海报管理',
                icon: 'el-icon-picture-outline',
                component: posterList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/popularize/article/list',
                name: '文章管理',
                icon: 'el-icon-tickets',
                component: articleList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/popularize/article/add',
                name: 'articleAdd',
                component: articleAdd,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/popularize/writings/list',
                name: '海报二维码文章',
                icon: 'el-icon-tickets',
                component: writingsList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/popularize/writings/add',
                name: 'writingsAdd',
                component: writingsAdd,
                meta: { requireAuth: true },
                children: []
            },
            //   {
            //     path: '/integral/list',
            //     name: '积分兑换管理',
            //     icon: 'el-icon-present',
            //     component: integralList,
            //     meta: { requireAuth: true },
            //     children: []
            //   },
            {
                path: '/front/advertise/list',
                name: '广告栏管理',
                icon: 'el-icon-film',
                component: advertiseList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/activity/list',
                name: '热门活动',
                icon: 'el-icon-mobile',
                component: activityList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/agreement/list',
                name: '协议管理',
                icon: 'el-icon-document',
                component: agreementList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/agreement/add',
                name: '新增协议',
                icon: 'el-icon-document',
                component: agreementAdd,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/wechat/setting',
                name: '小程序图片',
                icon: 'el-icon-document',
                component: wechatSetting,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/activityrule/list',
                name: '活动规则',
                icon: 'el-icon-document',
                component: activityRule,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/activityforword/list',
                name: '活动转发',
                icon: 'el-icon-document',
                component: activityForword,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/pointfabulou/list',
                name: '点赞管理',
                icon: 'el-icon-document',
                component: pointFabulou,
                meta: { requireAuth: true },
                children: []
            },
            //   {
            //     path: '/gift_order/gift/list',
            //     name: 'giftOrderList',
            //     component: giftOrderList,  // 礼品单列表
            //     meta: { requireAuth: true },
            //     children: []
            //   },
            {
                path: '/push/list',
                name: 'pushList',
                component: pushList,  // 礼品单列表
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/push/newPushList',
                name: 'newPushList',
                component: newPushList,  // 新增的礼品单列表
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/user/userInfo',
                name: 'userInfo',
                component: userInfo,  // 新增的个人信息审核
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/home/brand',
                name: '首页品牌',
                icon: 'el-icon-film',
                component: homeBrand,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/front/statistics',
                name: '数据统计',
                icon: 'el-icon-guide',
                component: statisticsList,
                meta: { requireAuth: true },
                children: []
            },
            {
                path: '/feedback/list',
                name: '反馈管理',
                icon: 'el-icon-film',
                component: feedbackList,
                children: []
            },
            // pushList
        ]
    }];

export default new Router({
    // mode: 'history',
    routes: [
        ...defaultRouter,
        ...addRouter
    ]
})
export { defaultRouter, addRouter }



// WEBPACK FOOTER //
// ./src/router/index.js